import buildSearchUrl from '~/utils/filters/buildSearchUrl'
import { useAnalyticalDataTracking } from '~/composables/analytics/useAnalyticalDataTracking'
import { MAX_SEARCH_TEXT_LENGTH } from '~/composables/constants/search/searchBar'
import { useManufacturers } from '~/composables/useManufacturers'
import buildManufacturerUrl from '~/utils/routing/buildManufacturerUrl'

export const useSearchBar = () => {
  const searchQuery = ref('')
  const isSearchOpen = ref(false)
  const router = useRouter()
  const elementRef = ref<HTMLDivElement | null>(null)

  const { fetch } = useManufacturers()

  router.afterEach(() => {
    isSearchOpen.value = false
  })

  const handleSearchOpenState = (state: boolean) => (isSearchOpen.value = state)
  const setRef = (ref: HTMLDivElement) => (elementRef.value = ref)

  const handleSubmit = async () => {
    const query = searchQuery.value?.trim()

    if (query?.length > 2) {
      const manufacturers = await fetch()

      await useAnalyticalDataTracking().trackMarketplaceSearchBarManualSearch({
        searchText: query,
      })

      if (manufacturers.length) {
        const manufacturer = manufacturers.find(
          (manufacturer) => String(manufacturer).toLowerCase() === String(query).toLowerCase()
        )

        if (manufacturer !== undefined) {
          return navigateTo(buildManufacturerUrl(manufacturer))
        }
      }

      return navigateTo(buildSearchUrl(query))
    }
  }

  const handleSearchBlur = () => {
    searchQuery.value = searchQuery.value.trim()
  }

  const collapseSearchDropdown = ({ target }: Event) => {
    if (!elementRef?.value?.contains(target as Node)) {
      handleSearchOpenState(false)
    }
  }

  onMounted(() => {
    window?.addEventListener('mousedown', collapseSearchDropdown)
  })

  onBeforeUnmount(() => {
    window?.removeEventListener('mousedown', collapseSearchDropdown)
  })

  const maxSearchTextLength = MAX_SEARCH_TEXT_LENGTH

  return {
    searchQuery,
    handleSubmit,
    isSearchOpen,
    handleSearchOpenState,
    setRef,
    maxSearchTextLength,
    handleSearchBlur,
  }
}
